import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquareStack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.42394 9.975H3.9C2.78625 9.975 1.875 9.06375 1.875 7.95V3.9C1.875 2.78625 2.78625 1.875 3.9 1.875H7.95C9.06375 1.875 9.975 2.78625 9.975 3.9V4.60608V5.42384M16.05 11.4988V9.975C16.05 8.86125 15.1388 7.95 14.025 7.95H9.975C8.86125 7.95 7.95 8.86125 7.95 9.975V14.025C7.95 15.1388 8.86125 16.05 9.975 16.05H11.4989M16.05 14.025H20.1C21.2184 14.025 22.125 14.9316 22.125 16.05V20.1C22.125 21.2184 21.2184 22.125 20.1 22.125H16.05C14.9316 22.125 14.025 21.2184 14.025 20.1V16.05C14.025 14.9316 14.9316 14.025 16.05 14.025Z",
		stroke: "currentColor",
		strokeWidth: 1.75,
		strokeLinejoin: "round"
	})
});
export default SvgSquareStack;
